<template>
  <div class="filtro k-filtercell">
    <div class="k-filtercell-wrapper">
      <!-- <span
        class="k-widget k-autocomplete k-autocomplete-clearable k-state-default"
      >-->
      <input
        class="k-textbox"
        ref="input"
        type="text"
        :value="value"
        @input="change"
        @keyup.enter="change"
      >
      <!-- </span> -->
      <div class="k-filtercell-operator">
        <select
          v-model="selected"
          class="k-textbox"
          ref="select"
          :value="operator"
          @change="change"
        >
          <option value="eq">Is Equal to</option>
          <option value="gt">Is greater then</option>
          <option value="lt">Is less then</option>
        </select>
        <button
          v-show="visibleFilterBtn"
          ref="button"
          type="button"
          class="k-button k-button-icon k-clear-button-visible"
          @click="reset"
        >
          <span class="k-icon k-i-filter-clear"></span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { Grid } from "@progress/kendo-vue-grid";

export default {
  name: "customNumericComponent",
  data() {
    return {
      visibleFilterBtn: false,
      selected: "eq"
    };
  },
  props: {
    grid: Grid,
    field: String,
    filterType: String,
    value: [String, Number, Boolean, Date],
    operator: String
  },
  methods: {
    change(ev) {
      this.visibleFilterBtn = this.$refs.input.value.length > 0;
      this.$emit("change", {
        operator: this.$refs.select.value,
        field: this.field,
        //value: parseFloat(this.$refs.input.value),
        value: this.$refs.input.value,
        syntheticEvent: ev
      });
    },
    reset(ev) {
      this.visibleFilterBtn = false;
      this.$emit("change", {
        operator: "Reset",
        field: "",
        value: "",
        syntheticEvent: ev
      });
    }
  }
};
</script>

<style>
.inputStyle {
  border-style: groove;
}
.filtro select {
  -webkit-appearance: menulist;
  border-style: groove;
}
.k-pager-sizes select {
  -webkit-appearance: menulist;
}
/* The container must be positioned relative: */
.custom-select {
  position: relative;
  font-family: Arial;
}

.custom-select select {
  display: none; /*hide original SELECT element: */
}

.select-selected {
  background-color: DodgerBlue;
}

/* Style the arrow inside the select element: */
.select-selected:after {
  position: absolute;
  content: "";
  top: 14px;
  right: 10px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-color: #fff transparent transparent transparent;
}
</style>
